import { Injectable } from '@angular/core';

/* @classdesc Classe que centralizará os registros de Log.
 * Foi criada como um serviço injetável para permitir uma possível
 * utilização de herança, uma vez que com métodos estáticos isso não seria possível.
*/
@Injectable({
  providedIn: 'root'
})
export class LogService {
  // public webService: WebService; //NÃO PODE USAR WEBSERVICE, UMA VEZ QUE WEBSERVICE USA LOGSERVICE

  constructor() {
    // this.webService = $injector.get(WebService);
    try {
    } catch (error) {
      console.log('LogService', 'constructor', error.message);
    }
  }

  protected static MAX_REPETITION_SAME_LOG = 3;
  protected static MAX_TOLERANCE_TO_REPETITION_SEG = 30;
  protected static arrayLog: Array<any> = [];
  protected static lastLog: LogService = null;
  protected static repetitionCount = 0;
  public static UsuarioLogadoNo = -1;
  public static ShowLogMessage = false;
  public static ShowConsoleLog = true;
  public static PersistLog = true;
  public static WsdlUrl = '';
  public static InterfaceMobileInstance: any = null;
  protected data: Date = null;
  protected classe = '';
  protected metodo = '';
  protected usuarioNo = -1;
  protected descricao = '';

  Registrar(classe: string, metodo: string, descricao: string): void {
    const msg: string = 'Classe: ' + classe + ' Método: ' + metodo + ' Descrição: ' + descricao;
    try {
      this.classe = classe;
      this.data = new Date();
      this.descricao = descricao;
      this.metodo = metodo;
      this.usuarioNo = LogService.UsuarioLogadoNo; // this.config.UsuarioLogadoNo;
      // _arrayLog.push(this); Pode provocar grande consumo de memória
      LogService.lastLog = this;
      if (LogService.ShowLogMessage) {
        // this.config.SHOWthis_MESSAGE
        this.showMessage(msg);
      }
      if (LogService.ShowConsoleLog) {
        console.log('LogService.showMessage:', msg);
      }
      if (LogService.PersistLog) {
        // this.config.PERSIST_LOG
        this.Salvar();
      }
    } catch (error) {
      console.log(msg + ' Log: ' + error.message);
      // showMessage(_msg + " Log: " + error.message);
    }
  }

  protected showMessage(msg: string): void {
    alert(msg); // LogService.InterfaceMobileInstance
  }

  /*
	 * Consumirá um serviço para carregamento dos dados
	 * @param _log
	 */
  public Salvar(): void {
    try {
      if (!this.checkRepetition()) {
        // Necessário achar uma solução sem chamar webservice, pois, o mesmo depende de logserviceÍ
        // this.done_SetLog(this.webService.connect("setLog", [
        // 	{ name: "classeNome", value: this._classe },
        // 	{ name: "yyyyMMddThhmmss", value: this.global.RetornarAllXsdDateTime(this._data) },
        // 	{ name: "descricao", value: this.global.PrepareToXML(this._descricao) },
        // 	{ name: "metodoNome", value: this._metodo },
        // 	{ name: "interfaceNo", value: this._usuarioNo }
        // ]));//1 é o Id da InterfaceWeb
      }
    } catch (error) {
      this.showMessage(' Log: ' + error.message);
    }
  }

  /*
	*Check if the Log is the same as the previous, within the same tolerance interval.
	* @param _log
	* @return
	*/
  public checkRepetition(): boolean {
    try {
      if (
        this.data <= this.DateAdd('s', LogService.MAX_TOLERANCE_TO_REPETITION_SEG, LogService.lastLog.data)
      ) {
        if (this.isTheSame(LogService.lastLog, this)) {
          LogService.repetitionCount++;
          if (LogService.repetitionCount > LogService.MAX_REPETITION_SAME_LOG) {
            return true;
          }
        }
      } else {
        LogService.repetitionCount = 0;
      }
    } catch (error) {
      this.showMessage('checkRepetition: ' + error.message);
    }
    return false;
  }

  protected isTheSame(lastLog: LogService, log: LogService): boolean {
    return (
      lastLog.descricao === log.descricao &&
      lastLog.metodo === log.metodo &&
      lastLog.classe === log.classe &&
      lastLog.usuarioNo === log.usuarioNo
    );
  }

  public done_SetLog(): void { }

  /*
* Adiciona um tempo a uma data
* @param datepart y adicionará anos, m meses, d dias
* @param number
* @param date
* @return
*/
  DateAdd(datepart: string = '', nmb: number = 0, date: Date = null): Date | null {
    try {
      if (date == null) {
        date = new Date();
      }
      const returnDate = new Date(date.valueOf());
      switch (datepart.toLowerCase()) {
        case 'y':
          returnDate.setFullYear(+returnDate.getFullYear() + +nmb);
          // returnDate["fullYear"] += number;
          break;
        case 'm':
          returnDate.setMonth(+returnDate.getMonth() + +nmb);
          // returnDate["month"] += number;
          break;
        case 'w':
          returnDate.setDate(+returnDate.getDate() + +nmb * 6);
          // returnDate["date"] += number * 6;
          break;
        case 'd':
          returnDate.setDate(+returnDate.getDate() + +nmb);
          break;
        default:
          /*Unknown date part, do nothing. */
          break;
      }
      return returnDate;
    } catch (error) {
      console.log(this.constructor.name, 'DateAdd', error.message);
    }
  }


}
